export default __webpack_public_path__ + "static/media/Icon awesome-thumbs-up.57388245.svg";